import { FlywireCheckoutSessionData, QuoteOutput, StudentDetails, TripDates } from '@lx/quote-tool/shared/types';
import { Amount } from '@lx/shared/data-access/types';
import { CourseDetails } from '@lx/quote-tool/lite/shared/types';
import { AyaDuration, BaseAccommodation, Step } from '../types';
import { Timezone } from '@lx/quote-tool/shared/types';
import { ClassTime } from '@lx/quote-tool/lite/online/types';
import { BasePremiumActivity } from '../types/premium-activity.type';
import { PrivateLesson } from '../types/private-lesson.type';
import { ResidenceDetails } from '../types/residence-details.type';
import { Flow, SchoolLocation } from '@lx/quote-tool/lite/shared/types';

/**
 * State of the Quote Tool Lite
 */
export interface QuoteToolLiteState {
  currentStep?: Step;
  activeFlow?: Flow;
  quoteId?: string;
  quote?: QuoteOutput;
  selectedLanguage?: string;
  selectedSchoolLocation?: SchoolLocation;
  selectedCourse?: CourseDetails;
  selectedDuration?: number;
  selectedAyaDuration?: AyaDuration;
  selectedStartDate?: string;
  selectedEndDate?: string;
  tripDates?: TripDates;
  selectedTimezone?: Timezone;
  selectedAccommodation?: BaseAccommodation;
  selectedInsuranceCode?: string;
  selectedUnaccompaniedMinorRows?: number[];
  selectedProfessionalImmersionExperienceCode?: string;
  selectedPremiumAccommodationCode?: string;
  selectedTransferRows?: number[];
  selectedPrivateLesson?: PrivateLesson;
  juniorCourseUpgrade?: boolean;
  upselling?: boolean;
  selectedCurrency?: string;
  selectedResidence?: ResidenceDetails;
  studentDetails?: StudentDetails;
  selectedPremiumActivities?: BasePremiumActivity[];
  selectedClassTime?: ClassTime;
  depositAmounts?: Amount[];
  flywireCheckoutSessionData?: FlywireCheckoutSessionData;
  requestedQuotes?: number; // Number of quotes requested. Every time users click on Start again button, this number will increase by 1
  deeplinkType?: string;
}
